import Swal from "sweetalert2";

export const fire = (title, text, icon = 'error', buttonText = 'OK') => {

  return Swal.fire({
    title: title,
    html: text,
    icon: icon,
    confirmButtonText: buttonText
  });
};
